module.exports = __webpack_public_path__ + "static/media/Indonesia logo white-01.dc527fc9.png";